import React from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
export const wrapPageElement = ({ element }, { helmet }) => (React.createElement(React.Fragment, null,
    React.createElement(Helmet, Object.assign({}, helmet)),
    element));
export const wrapRootElement = ({ element, }) => React.createElement(HelmetProvider, null, element);
